module.exports = __webpack_public_path__ + "assets/d71e7f629824097776cc59f3faac7684.png";